function Accordion(item, body, header) {
    $(`${item}:not(.active)`).find(`${body}`).slideUp(0);
    $(`${item}.active`).find(`> ${body}`).show();

    $(`${item}`).on('click', `${header}`, function (e) {
        e.preventDefault();
        e.stopPropagation();

        const parent = $(this).closest(item);

        parent.toggleClass('active');
        $(this).toggleClass('active');
        parent.find(`${body}`).slideToggle(400);
    });
}

function AccordionHead(item, body, header) {
    $(`${item}:not(.active)`).find(`${body}`).slideUp(0);
    $(`${item}.active`).find(`> ${body}`).show();

    $(`${item}`).on('click', header, function () {
        $(this).parent().toggleClass('active');
        $(this).parent().find(`${header}`).toggleClass('active');
        $(this).parent().find(`${body}`).slideToggle(400);
    });
}

function AccordionOpacity(item, body, header) {
    $(`${item}:not(.active)`).find(`${body}`).css('opacity', 0).slideUp(0);
    $(`${item}.active`).find(`> ${body}`).css('opacity', 1).show();

    $(`${item}`).on('click', `${header}`, function (e) {
        e.preventDefault();
        e.stopPropagation();

        const parent = $(this).closest(item);
        const bodyElement = parent.find(`${body}`);

        parent.toggleClass('active');
        $(this).toggleClass('active');

        if (parent.hasClass('active')) {
            bodyElement.stop(true, true).css('opacity', 0).slideDown({
                duration: 700,
                step: function (now, fx) {
                    if (fx.prop === 'height') {
                        $(this).css('opacity', now / fx.end);
                    }
                },
                complete: function () {
                    $(this).css('opacity', 1);
                }
            });
        } else {
            bodyElement.stop(true, true).css('opacity', 1).slideUp({
                duration: 700,
                step: function (now, fx) {
                    if (fx.prop === 'height') {
                        $(this).css('opacity', 1 - (now / fx.start));
                    }
                },
                complete: function () {
                    $(this).css('opacity', 0);
                }
            });
        }
    });
}

if ($('.js-faq-accordion').length) {
    Accordion(
        '.js-faq-accordion-item',
        '.js-faq-accordion-body',
        '.js-faq-accordion-header'
    );
}

if ($('.js-sources-accordion').length) {
    Accordion(
        '.js-sources-accordion-item',
        '.js-sources-accordion-body',
        '.js-sources-accordion-header'
    );
}

if ($('.js-t-approach-accordion').length) {
    Accordion(
        '.js-t-approach-accordion-item',
        '.js-t-approach-accordion-body',
        '.approach-accordion-header'
    );
}

if ($('.js-h-services-accordion').length) {
    AccordionOpacity(
        '.js-h-services-accordion',
        '.js-h-services-accordion-body',
        '.js-h-services-accordion-open'
    );
}

if ($('.js-g-tab-accordion').length) {
    AccordionHead(
        '.js-g-tab-accordion',
        '.js-g-tab-accordion-body',
        '.js-g-tab-accordion-open'
    );
}